import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { EvTariffInformationSteps } from './EvTariffInformationSteps';
import { EvTariffRateInfo } from './EvTariffRateInfo';

import { useNavigation } from 'hooks/useNavigation';
import { NsCard } from 'components/common/ns-card/NsCard';
import NsColumn from '@britishgasenergy/react-nucleus/dist/nuc-components/NsColumn';
import { NsContent } from 'components/common/ns-content/NsContent';

export const evTariffInformationContentTestId =
  'evTariffInformationContentTestId';

const EvTariffInformationContent = () => {
  const { next, eventTypes } = useNavigation();
  const handleNext = () => {
    next({ eventType: eventTypes.NEXT });
  };
  return (
    <NsCard testId={evTariffInformationContentTestId}>
      <NsColumn hockeypitch="2:1">
        <NsContent>
          <EvTariffRateInfo />
          <EvTariffInformationSteps />
          <NsPrimaryCta onClick={handleNext}>Choose a tariff</NsPrimaryCta>
        </NsContent>
      </NsColumn>
    </NsCard>
  );
};

export default EvTariffInformationContent;
